import { api, type NewsItem } from "../api.js";
import { h } from "../ui.js";

/** News feed: pinned hand posts, then releases from the generated changelog (platform spec §6.2). */
export function newsFeed(limit = 20): HTMLElement {
  const box = h("div", { class: "news" }, h("p", { class: "dim" }, "Loading news…"));
  void api.news().then((items) => {
    const sorted = [...items].sort((a, b) => Number(!!b.pinned) - Number(!!a.pinned) || b.date.localeCompare(a.date)).slice(0, limit);
    box.replaceChildren(...(sorted.length ? sorted.map(article) : [h("p", { class: "dim" }, "No news yet.")]));
  });
  return box;
}

function article(n: NewsItem): HTMLElement {
  return h("article", {},
    h("div", { class: "d mono-num" },
      n.date,
      n.pinned ? h("em", { class: "pin" }, "pinned") : null,
      n.kind === "release" && n.version ? h("em", {}, n.version) : null,
    ),
    h("div", {}, h("h3", {}, n.title), h("div", { html: n.html })),
  );
}
